import { calculaValoresFrete } from '@sotran/lib-shipper';

import { getFaixaTarifaTmov } from '../../../../../../../helpers/calculaValoresLote';
import { removeMoedaMask } from '../../../../../../../helpers/formatador';
import PedagioEnum from '../../../../../Enum/PedagioEnum';

export const calculaFrete = ({
  value,
  tipo,
  valorPedagio,
  tarifaTmov,
  isTarifaPercentual,
}) => {
  const valor = removeMoedaMask(value || 0);

  const resultado = calculaValoresFrete(
    valor,
    tipo,
    tarifaTmov,
    isTarifaPercentual,
    0,
    valorPedagio
  );

  return resultado;
};

function calculafretesPjePf(
  tarifaTmovClienteLista,
  fretePj,
  fretePf,
  isTarifaPercentual,
  pedagio,
  valorPedagio,
  tipo
) {
  const tarifaTmov = getFaixaTarifaTmov(
    'PJ',
    tarifaTmovClienteLista,
    fretePj,
    isTarifaPercentual
  );
  const novoPedagio =
    pedagio === PedagioEnum.PEDAGIO_INCLUSO ? 0 : valorPedagio;
  const valorCalculado = calculaFrete({
    value: fretePj,
    tipo,
    valorPedagio: novoPedagio,
    tarifaTmov,
    isTarifaPercentual,
  });

  return {
    fretePj: valorCalculado,
    fretePf:
      fretePj === fretePf
        ? valorCalculado
        : calculaFrete({
            value: fretePf,
            tipo: 'freteMotorista',
            valorPedagio: novoPedagio,
            tarifaTmov,
            isTarifaPercentual,
          }),
  };
}

export const recalculaFretes = ({
  baseFreteShipper,
  pedagio,
  valorPedagio,
  tarifaTmovClienteLista,
  isTarifaPercentual,
  freteMotoristaPf,
  freteMotoristaPj,
  freteTotalPf,
  freteTotalPj,
}) => {
  if (baseFreteShipper === 'motorista') {
    const { fretePj, fretePf } = calculafretesPjePf(
      tarifaTmovClienteLista,
      freteMotoristaPj,
      freteMotoristaPf,
      isTarifaPercentual,
      pedagio,
      valorPedagio,
      'freteMotorista'
    );
    return {
      freteMotoristaPf,
      freteMotoristaPj,
      freteTotalPf: fretePf,
      freteTotalPj: fretePj,
    };
  }
  const { fretePj, fretePf } = calculafretesPjePf(
    tarifaTmovClienteLista,
    freteTotalPj,
    freteTotalPf,
    isTarifaPercentual,
    pedagio,
    valorPedagio,
    'freteEmpresa'
  );
  return {
    freteMotoristaPf: fretePf,
    freteMotoristaPj: fretePj,
    freteTotalPf,
    freteTotalPj,
  };
};
